import { render, staticRenderFns } from "./QuotesDataTable.template.vue?vue&type=template&id=0c5bc85a&scoped=true&"
var script = {}
import style0 from "./QuotesDataTable.template.vue?vue&type=style&index=0&id=0c5bc85a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5bc85a",
  null
  
)

export default component.exports